import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const [accentColor, setAccentColor] = useState('maroon');
  const [backgroundPattern, setBackgroundPattern] = useState('none');
  const [fontSize, setFontSize] = useState('medium');

  // Load theme settings from localStorage on mount
  useEffect(() => {
    try {
    const savedTheme = localStorage.getItem('theme') || 'light';
    const savedAccentColor = localStorage.getItem('accentColor') || 'maroon';
    const savedBackgroundPattern = localStorage.getItem('backgroundPattern') || 'none';
    const savedFontSize = localStorage.getItem('fontSize') || 'medium';
    
    setTheme(savedTheme);
    setAccentColor(savedAccentColor);
    setBackgroundPattern(savedBackgroundPattern);
    setFontSize(savedFontSize);
    } catch { /* Browser preferences are optional when storage is restricted. */ }
  }, []);

  // Save to localStorage whenever values change
  useEffect(() => {
    try { localStorage.setItem('theme', theme); } catch { /* Keep the in-memory preference. */ }
  }, [theme]);

  useEffect(() => {
    try { localStorage.setItem('accentColor', accentColor); } catch { /* Keep the in-memory preference. */ }
  }, [accentColor]);

  useEffect(() => {
    try { localStorage.setItem('backgroundPattern', backgroundPattern); } catch { /* Keep the in-memory preference. */ }
  }, [backgroundPattern]);

  useEffect(() => {
    try { localStorage.setItem('fontSize', fontSize); } catch { /* Keep the in-memory preference. */ }
  }, [fontSize]);

  const updateAppearance = (settings) => {
    if (settings.theme !== undefined) setTheme(settings.theme);
    if (settings.accentColor !== undefined) setAccentColor(settings.accentColor);
    if (settings.backgroundPattern !== undefined) setBackgroundPattern(settings.backgroundPattern);
    if (settings.fontSize !== undefined) setFontSize(settings.fontSize);
  };

  const value = {
    theme,
    setTheme,
    accentColor,
    setAccentColor,
    backgroundPattern,
    setBackgroundPattern,
    fontSize,
    setFontSize,
    updateAppearance
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};